// English (default) translations
const en = {
    // Nav
    "nav.home": "HOME",
    "nav.settings": "SETTINGS",
    "nav.exit": "EXIT",
    "nav.inventory": "INVENTORY",
    "nav.loadout": "LOADOUT",
    "nav.play": "PLAY",
    "nav.store": "STORE",
    "nav.news": "NEWS",
    "nav.friends": "FRIENDS",
    "nav.recordings": "RECORDINGS",
    "nav.profile": "PROFILE",

    // Common
    "common.close": "Close",
    "common.back": "Back",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.copy": "Copy",
    "common.share": "Share",
    "common.locked": "Locked",
    "common.unavailable": "Unavailable in Beta",
    "common.beta": "BETA",
    "common.online": "Online",
    "common.offline": "Offline",

    // Lobby
    "lobby.status": "READY FOR DEPLOYMENT",
    "lobby.slot_left": "Team Slot",
    "lobby.slot_right": "Team Slot",
    "lobby.slot_disabled": "Party invitations are not available in the Beta version.",
    "lobby.mini_status": "STANDBY",

    // Play
    "play.title": "DEPLOYMENT",
    "play.subtitle": "SELECT MISSION",
    "play.mode_training": "TRAINING",
    "play.mode_training_sub": "VS AI · OFFLINE",
    "play.mode_ranked": "RANKED MULTIPLAYER",
    "play.mode_ranked_sub": "COMPETITIVE · ONLINE",
    "play.available": "AVAILABLE",
    "play.beta_lock": "BETA LOCK",
    "play.section_map": "MAP",
    "play.section_team": "TEAM SIZE",
    "play.section_difficulty": "BOT DIFFICULTY",
    "play.deploy": "DEPLOY",
    "play.last_loadout": "LAST LOADOUT",

    // Store
    "store.title": "STORE",
    "store.subtitle": "SKINS · CAPSULES · BUNDLES",
    "store.locked_title": "Store Locked",
    "store.locked_message": "Store is not available in the current Beta build.",

    // News
    "news.title": "NEWS",
    "news.subtitle": "PATCH NOTES · ANNOUNCEMENTS",

    // Loadout
    "loadout.title": "LOADOUT",
    "loadout.subtitle": "PRIMARY · SECONDARY · MELEE · GRENADES",
    "loadout.slot_primary": "PRIMARY",
    "loadout.slot_secondary": "SECONDARY",
    "loadout.slot_melee": "MELEE",
    "loadout.slot_grenade": "GRENADE",
    "loadout.slot_pistol_start": "STARTING PISTOL",
    "loadout.save": "Save Loadout",
    "loadout.saved": "Loadout saved",

    // Inventory
    "inventory.title": "INVENTORY",
    "inventory.subtitle": "WEAPON BALANCE · SKINS",

    // Friends
    "friends.title": "FRIENDS",
    "friends.subtitle": "SQUAD UP",
    "friends.add": "Add Friend",
    "friends.my_code": "My Friend Code",
    "friends.copy_code": "Copy Code",
    "friends.reset_code": "Reset Code",
    "friends.incoming": "Incoming Requests",
    "friends.sent": "Sent Requests",
    "friends.online": "Online",
    "friends.offline": "Offline",
    "friends.blocked": "Blocked",
    "friends.search": "Search",
    "friends.remove": "Remove",
    "friends.block": "Block",
    "friends.unavailable": "Online friends are unavailable during the Beta.",

    // Recordings
    "recordings.title": "RECORDINGS",
    "recordings.subtitle": "MANUAL CLIP CAPTURE",
    "recordings.start": "Start New Recording",
    "recordings.stop": "Stop Recording",
    "recordings.mine": "My Recordings",
    "recordings.play": "Play",
    "recordings.rename": "Rename",
    "recordings.delete": "Delete",
    "recordings.download": "Download",
    "recordings.experimental":
        "Recording is experimental in the Beta — browser capture APIs are used and quality may vary.",
    "recordings.indicator": "REC",

    // Exit
    "exit.title": "Exit CROSSFIRE",
    "exit.message": "Are you sure you want to exit CROSSFIRE?",
    "exit.confirm": "EXIT GAME",

    // Profile
    "profile.title": "PROFILE",
    "profile.subtitle": "OPERATOR",
    "profile.level": "LEVEL",
    "profile.xp": "XP",
    "profile.matches": "MATCHES",
    "profile.wins": "WINS",
    "profile.losses": "LOSSES",
    "profile.kills": "KILLS",
    "profile.deaths": "DEATHS",
    "profile.kd": "K/D",
    "profile.rank": "RANK",
    "profile.rank_beta": "BETA UNRANKED",
    "profile.player_id": "PLAYER ID",
    "profile.account": "ACCOUNT",
    "profile.account_beta": "BETA GUEST",

    // Settings tabs
    "settings.title": "SETTINGS",
    "settings.tab.graphics": "Graphics",
    "settings.tab.audio": "Audio",
    "settings.tab.controls": "Controls",
    "settings.tab.gameplay": "Gameplay",
    "settings.tab.language": "Language",
};

export default en;
